import React, { forwardRef } from "react";
import { outboundLink } from "../lib/Analytics";

const OutboundLink = ({
    id = null,
    href,
    title = null,
    style = null,
    className = null,
    targetBlank = true,
    onClick = f => f,
    children,
    trackLink = true,
    disabled = false,
    ...otherProps  // Capture remaining props like data-source-id
  }) => {
  const cn = className ? `${className}${disabled ? " disabled" : ""}` : disabled ? "disabled" : null;
  return (href && <a
    {...(id && { id })}
    target={targetBlank ? "_blank" : null}
    rel="noopener noreferrer"
    title={title}
    href={href}
    style={style}
    className={cn}
    {...otherProps}  // Forward data-* attributes and other props
    onClick={e => {
      if (!disabled) {
        if (trackLink) {
          outboundLink({label: href}, () => {
          });
        }
        onClick(e);
      }
    }}
  >
    {children}
  </a>)
         || (<span {...(id && {id })} title={title} className={className}>{children}</span>);
};

export default OutboundLink;
